import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import StarsOutlinedIcon from "@mui/icons-material/StarsOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";

export const FINANCE_ICONS = {
  dashboard: DashboardOutlinedIcon,
  analysis: ShowChartOutlinedIcon,
  tiers: StarsOutlinedIcon,
  brandfees: BadgeOutlinedIcon,
  memberships: CardMembershipOutlinedIcon,
  compensations: RequestQuoteOutlinedIcon,
  transactions: SwapVertOutlinedIcon,
  register: DescriptionOutlinedIcon,
  invoices: PictureAsPdfOutlinedIcon,
  workflow: AccountTreeOutlinedIcon,
  payouts: PaymentsOutlinedIcon,
  dueboard: ChecklistOutlinedIcon,
  duepayouts: ScheduleOutlinedIcon,
  unpaid: WarningAmberOutlinedIcon,
  expenses: ReceiptLongOutlinedIcon,
  overstock: Inventory2OutlinedIcon,
  vendors: StorefrontOutlinedIcon,
  accounts: AccountBalanceOutlinedIcon,
  cash: AccountBalanceWalletOutlinedIcon,
  reports: AssessmentOutlinedIcon,
  audit: HistoryOutlinedIcon,
};

const ADD_TX = "/warehousing/finance/transactions/add";
const ADD_PAYOUT = "/warehousing/finance/payouts/add";
const ADD_FEE = "/warehousing/finance/fees";

export const financeGroups = (hideInhouse) =>
  [
    {
      name: "Overview",
      items: [
        { key: "dashboard", label: "Finance Dashboard", path: "/warehousing/finance", exact: true },
        { key: "analysis", label: "Transaction Analysis", path: "/warehousing/finance/analysis", inhouse: true },
      ],
    },
    {
      name: "Revenue",
      items: [
        { key: "tiers", label: "Service Fee Tiers", path: "/warehousing/finance/service-fee-tiers", inhouse: true },
        { key: "brandfees", label: "Brand Service Fees", path: "/warehousing/finance/brand-service-fees", inhouse: true },
        { key: "memberships", label: "Products & Memberships", path: "/warehousing/finance/memberships", inhouse: true },
        { key: "compensations", label: "Fees & Compensations", path: "/warehousing/finance/fees-compensations" },
      ],
    },
    {
      name: "Transactions",
      items: [
        { key: "transactions", label: "Transactions", path: "/warehousing/finance/transactions" },
      ],
    },
    {
      name: "Payables & Receivables",
      items: [
        { key: "register", label: "Invoice Register", path: "/warehousing/finance/invoice-register", inhouse: true },
        { key: "invoices", label: "Invoice Extract", path: "/warehousing/finance/invoices", exact: true },
        { key: "workflow", label: "Payout Workflow", path: "/warehousing/finance/payouts/workflow", inhouse: true },
        { key: "payouts", label: "Payouts", path: "/warehousing/finance/payouts", exact: true },
        { key: "dueboard", label: "Due Board", path: "/warehousing/finance/payouts/due-board", inhouse: true },
        { key: "duepayouts", label: "Due Payouts", path: "/warehousing/finance/payouts/due", exact: true },
        { key: "unpaid", label: "Unpaid Orders", path: "/warehousing/finance/orders" },
      ],
    },
    {
      name: "Expenses",
      items: [
        { key: "expenses", label: "Expenses", path: "/warehousing/finance/expenses", inhouse: true },
        { key: "overstock", label: "Overstock Calculator", path: "/warehousing/finance/overstock", inhouse: true },
        { key: "vendors", label: "Vendor Management", path: "/warehousing/finance/vendors" },
      ],
    },
    {
      name: "Reporting",
      items: [
        { key: "accounts", label: "Chart of Accounts", path: "/warehousing/finance/accounts", inhouse: true },
        { key: "cash", label: "Cash & Bank", path: "/warehousing/finance/cash-bank", inhouse: true },
        { key: "reports", label: "Financial Reports", path: "/warehousing/finance/reports", inhouse: true },
        { key: "audit", label: "Audit Log", path: "/warehousing/finance/audit" },
      ],
    },
  ].map((group) => ({
    ...group,
    items: group.items.filter((item) => !hideInhouse || !item.inhouse),
  })).filter((group) => group.items.length);

export const isFinanceItemActive = (item, pathname) => {
  if (item.key === "payouts") return pathname === item.path || pathname.startsWith(`${item.path}/add`);
  if (item.key === "transactions") return pathname === item.path || pathname.startsWith(`${item.path}/`);
  if (item.key === "vendors") return pathname === item.path || pathname.startsWith(`${item.path}/`);
  if (item.key === "compensations") {
    return pathname === item.path || pathname.startsWith("/warehousing/finance/fees");
  }
  return pathname === item.path;
};

const page = (title, group, extra = {}) => ({ title, group, ...extra });

export const financePageMeta = (pathname) => {
  const pages = [
    { match: (p) => p === "/warehousing/finance/login", ...page("Sign in", "Finance OS", { bare: true }) },
    { match: (p) => p.startsWith("/warehousing/finance/transactions/import"), ...page("Import Progress", "Transactions") },
    { match: (p) => p.startsWith(ADD_TX), ...page("Add Transactions", "Transactions") },
    { match: (p) => p.startsWith("/warehousing/finance/analysis"), ...page("Transaction Analysis", "Overview") },
    { match: (p) => p.startsWith("/warehousing/finance/transactions"), ...page("Transactions", "Transactions", { primary: { label: "Add Transaction", to: ADD_TX } }) },
    { match: (p) => p.startsWith(ADD_PAYOUT), ...page("Add Payouts", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/payouts/workflow"), ...page("Payout Workflow", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/payouts/due-board"), ...page("Due Board", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/payouts/due"), ...page("Due Payouts", "Payables & Receivables", { primary: { label: "Add Payout", to: ADD_PAYOUT } }) },
    { match: (p) => p.startsWith("/warehousing/finance/payouts"), ...page("Payouts", "Payables & Receivables", { primary: { label: "Add Payout", to: ADD_PAYOUT } }) },
    { match: (p) => p.startsWith("/warehousing/finance/orders"), ...page("Unpaid Orders", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/fees-compensations"), ...page("Fees & Compensations", "Revenue", { primary: { label: "Add Fee", to: ADD_FEE } }) },
    { match: (p) => p.startsWith(ADD_FEE), ...page("Add Fees", "Revenue") },
    { match: (p) => p.startsWith("/warehousing/finance/invoice-register"), ...page("Invoice Register", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/invoices"), ...page("Invoice Extract", "Payables & Receivables") },
    { match: (p) => p.startsWith("/warehousing/finance/service-fee-tiers"), ...page("Service Fee Tiers", "Revenue", { primary: { label: "New Tier", event: "fo-new-tier" } }) },
    { match: (p) => p.startsWith("/warehousing/finance/brand-service-fees"), ...page("Brand Service Fees", "Revenue") },
    { match: (p) => p.startsWith("/warehousing/finance/memberships"), ...page("Products & Memberships", "Revenue") },
    { match: (p) => p.startsWith("/warehousing/finance/accounts"), ...page("Chart of Accounts", "Reporting") },
    { match: (p) => p.startsWith("/warehousing/finance/overstock"), ...page("Overstock Calculator", "Expenses") },
    { match: (p) => p.startsWith("/warehousing/finance/expenses"), ...page("Expenses", "Expenses") },
    { match: (p) => p.startsWith("/warehousing/finance/cash-bank"), ...page("Cash & Bank", "Reporting") },
    { match: (p) => p.startsWith("/warehousing/finance/reports"), ...page("Financial Reports", "Reporting") },
    { match: (p) => p.startsWith("/warehousing/finance/audit"), ...page("Audit Log", "Reporting") },
    { match: (p) => /^\/warehousing\/finance\/vendors\/.+/.test(p), ...page("Vendor", "Expenses") },
    { match: (p) => p.startsWith("/warehousing/finance/vendors"), ...page("Vendor Management", "Expenses") },
    { match: (p) => p === "/warehousing/finance", ...page("Finance Dashboard", "Overview", { primary: { label: "New Transaction", to: ADD_TX } }) },
  ];
  return pages.find((entry) => entry.match(pathname)) || { title: "Finance OS", group: "Overview" };
};
